module.exports = __webpack_public_path__ + "media/hallBgm.a6d7e334.mp3";